var _excluded = ["params", "body", "headers"],
  _excluded2 = ["params", "headers", "cache"];
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { useCampaignStore } from '@/entities/campaign/model';
import { AUTH_COOKIE_NAME } from '@/shared/api/constants/authCookieName';
import { retrieveLaunchParams } from '@telegram-apps/sdk-react';
import Cookies from 'js-cookie';
import JSONbigFactory from 'json-bigint';
import { toast } from '../ui/Toast/ui/ToastContainer';
import { API_EVENT_EMITTER } from './ApiEventEmitter';
import { ERROR_MESSAGES } from './constants';
var JSONbigFast = JSONbigFactory({
  alwaysParseAsBig: false,
  useNativeBigInt: true
});
var JSONbigSafe = JSONbigFactory({
  storeAsString: true
});
var SAFE_MIN = BigInt(Number.MIN_SAFE_INTEGER);
var SAFE_MAX = BigInt(Number.MAX_SAFE_INTEGER);
function isIntegerString(s) {
  return /^-?\d+$/.test(s);
}
function isFloatString(s) {
  // eslint-disable-next-line no-useless-escape
  return /[.\eE]/.test(s) && /^-?\d+(\.\d+)?([eE][+-]?\d+)?$/.test(s);
}
function convertValue(value) {
  if (typeof value === 'bigint') {
    // привести в number если безопасно
    if (value >= SAFE_MIN && value <= SAFE_MAX) return Number(value);
    return value;
  }
  if (typeof value === 'string') {
    // если строка выглядит как целое число
    if (isIntegerString(value)) {
      try {
        var bi = BigInt(value);
        if (bi >= SAFE_MIN && bi <= SAFE_MAX) return Number(bi);
        return bi;
      } catch (_unused) {
        // если не преобразуется в BigInt (очень редко) — вернуть строку
        return value;
      }
    }

    // если строка похожа на дробь/экспоненту -> number
    if (isFloatString(value)) {
      var n = Number(value);
      return Number.isFinite(n) ? n : value;
    }

    // не число — вернуть строку
    return value;
  }
  if (Array.isArray(value)) return value.map(convertValue);
  if (value && _typeof(value) === 'object') {
    var out = {};

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    for (var _i = 0, _Object$entries = Object.entries(value); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        k = _Object$entries$_i[0],
        v = _Object$entries$_i[1];
      out[k] = convertValue(v);
    }
    return out;
  }

  // number, boolean, null и т.п.
  return value;
}
export function parseJsonSmart(jsonText) {
  try {
    // быстрый проход
    var parsed = JSONbigFast.parse(jsonText);
    return convertValue(parsed);
  } catch (_unused2) {
    // fallback: парсим всё как строки, чтобы избежать ошибок BigInt при дробях
    var _parsed = JSONbigSafe.parse(jsonText);
    return convertValue(_parsed);
  }
}
export var objectToURLSearchParams = function objectToURLSearchParams(parameters) {
  var searchParameters = new URLSearchParams();
  for (var _i2 = 0, _Object$keys = Object.keys(parameters !== null && parameters !== void 0 ? parameters : {}); _i2 < _Object$keys.length; _i2++) {
    var key = _Object$keys[_i2];
    var value = parameters === null || parameters === void 0 ? void 0 : parameters[key];
    if (value) {
      searchParameters.append(key, String(value).replaceAll('+', ','));
    }
  }
  return searchParameters.toString();
};
var addHeaderIfExists = function addHeaderIfExists(key, value) {
  return value ? _defineProperty({}, key, value) : {};
};

// Преобразовывает конфиг, напоминающий axios к виду, который ожидает fetch
var getRequestConfig = function getRequestConfig(method, config) {
  var _headers$ContentType;
  var params = config.params,
    body = config.body,
    _config$headers = config.headers,
    headers = _config$headers === void 0 ? {} : _config$headers,
    other = _objectWithoutProperties(config, _excluded);
  var isFormData = body instanceof FormData;
  var isGet = method === 'GET';
  var contentType = (_headers$ContentType = headers['Content-Type']) !== null && _headers$ContentType !== void 0 ? _headers$ContentType : 'application/json';
  if (isFormData && !headers['Content-Type'] || isGet) {
    delete headers['Content-Type'];
  } else {
    headers['Content-Type'] = contentType;
  }
  var requestConfig = _objectSpread(_objectSpread({}, other), {}, {
    headers: headers,
    method: method
  });
  if (body) {
    if (isFormData) {
      requestConfig.body = body;
    } else if (contentType === 'application/x-www-form-urlencoded') {
      requestConfig.body = objectToURLSearchParams(body);
    } else if (contentType === 'application/json') {
      requestConfig.body = JSONbigSafe.stringify(body);
    } else {
      throw new Error("Unsupported Content-Type: ".concat(contentType));
    }
  }
  if (params) {
    requestConfig.params = objectToURLSearchParams(params);
  }
  return requestConfig;
};
var getCookies = function getCookies() {
  // let i18NEXT_LOCALE;
  // let session_id;

  // const jsCookieModule = await import('js-cookie');
  // const jsCookie = jsCookieModule.default;

  //const i18NEXT_LOCALE = Cookies.get('i18next');
  var SESSION_TOKEN = Cookies.get(AUTH_COOKIE_NAME);
  return {
    Authorization: SESSION_TOKEN || ''
    //Language: i18NEXT_LOCALE || 'en',
  };
};

// Формирует и выполняет запрос
function requestConfig(_x, _x2) {
  return _requestConfig.apply(this, arguments);
}
function _requestConfig() {
  _requestConfig = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(api, route) {
    var config,
      _useCampaignStore$get,
      campaignId,
      params,
      headers,
      _config$cache,
      cache,
      init,
      _url,
      launchParameters,
      cookies,
      baseHeaders,
      initParameters,
      res,
      body,
      rawText,
      lang,
      text,
      parsed,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          config = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          _context.prev = 1;
          _useCampaignStore$get = useCampaignStore.getState(), campaignId = _useCampaignStore$get.campaignId;
          params = config.params, headers = config.headers, _config$cache = config.cache, cache = _config$cache === void 0 ? 'no-cache' : _config$cache, init = _objectWithoutProperties(config, _excluded2);
          _url = "".concat(api, "/").concat(route).concat(params ? "?".concat(params) : '');
          launchParameters = retrieveLaunchParams();
          _context.next = 8;
          return getCookies();
        case 8:
          cookies = _context.sent;
          baseHeaders = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
            'Content-Type': 'application/json; charset=utf-8'
          }, cookies), headers), addHeaderIfExists('X-Campaign-Id', campaignId)), campaignId ? addHeaderIfExists('X-Click-Id', launchParameters.tgWebAppStartParam) : {});
          if (launchParameters.tgWebAppStartParam !== undefined && !campaignId) {
            baseHeaders.Promocode = launchParameters.tgWebAppStartParam;
          }
          initParameters = _objectSpread({
            cache: cache,
            headers: baseHeaders
          }, init);
          _context.next = 14;
          return fetch(_url, initParameters);
        case 14:
          res = _context.sent;
          if (res.ok) {
            _context.next = 30;
            break;
          }
          body = null;
          rawText = '';
          _context.next = 20;
          return res.text();
        case 20:
          rawText = _context.sent;
          try {
            body = parseJsonSmart(rawText);
          } catch (_unused3) {
            body = {
              message: rawText
            };
          }
          if (!(res.status < 500)) {
            _context.next = 27;
            break;
          }
          if (res.status === 401) {
            API_EVENT_EMITTER.emit('apiError', {
              response: {
                data: body
              },
              status: res.status
            });
            // if (body?.enable_two_fa === undefined && body?.pin_code === undefined) {
            // 	API_EVENT_EMITTER.emit('logout');
            // }
          }
          throw {
            response: {
              data: body
            },
            status: res.status
          };
        case 27:
          lang = Cookies.get('i18next');
          toast.error(String(body.message) || ERROR_MESSAGES[lang || 'en']);
          throw {
            response: {
              data: null
            },
            status: res.status
          };
        case 30:
          if (!(res.status === 204)) {
            _context.next = 34;
            break;
          }
          _context.next = 33;
          return Promise.resolve({});
        case 33:
          return _context.abrupt("return", _context.sent);
        case 34:
          _context.next = 36;
          return res.text();
        case 36:
          text = _context.sent;
          _context.prev = 37;
          parsed = parseJsonSmart(text);
          if (!(_typeof(parsed) === 'object' && parsed !== null || Array.isArray(parsed))) {
            _context.next = 43;
            break;
          }
          _context.t0 = parsed;
          _context.next = 46;
          break;
        case 43:
          _context.next = 45;
          return Promise.resolve({});
        case 45:
          _context.t0 = _context.sent;
        case 46:
          return _context.abrupt("return", _context.t0);
        case 49:
          _context.prev = 49;
          _context.t1 = _context["catch"](37);
          console.log(_context.t1);
          _context.next = 54;
          return Promise.resolve({});
        case 54:
          return _context.abrupt("return", _context.sent);
        case 55:
          _context.next = 61;
          break;
        case 57:
          _context.prev = 57;
          _context.t2 = _context["catch"](1);
          if ((_context.t2 === null || _context.t2 === void 0 ? void 0 : _context.t2.status) === 401) {
            API_EVENT_EMITTER.emit('apiError', {
              status: _context.t2
            });

            // if (
            // 	(error as IResponseErrors)?.response?.data?.enable_two_fa === undefined &&
            // 	(error as IResponseErrors)?.response?.data?.pin_code === undefined
            // )
            // 	API_EVENT_EMITTER.emit('logout');
          }

          // console.error('Error during request:', error);
          throw _context.t2;
        case 61:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 57], [37, 49]]);
  }));
  return _requestConfig.apply(this, arguments);
}
export function createApiFetch(api) {
  return {
    // eslint-disable-next-line max-len
    delete: function _delete(url) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return requestConfig(api, url, getRequestConfig('DELETE', config));
    },
    // eslint-disable-next-line max-len
    get: function get(url) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return requestConfig(api, url, getRequestConfig('GET', config));
    },
    // eslint-disable-next-line max-len
    post: function post(url) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return requestConfig(api, url, getRequestConfig('POST', config));
    },
    // eslint-disable-next-line max-len
    put: function put(url) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return requestConfig(api, url, getRequestConfig('PUT', config));
    }
  };
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
var appApi = createApiFetch(process.env.BASE_URL_API);
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
var geoApi = createApiFetch(process.env.GEO_API_URL);
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
var ticketControlApi = createApiFetch(process.env.TICKET_CONTROL_API);
export default appApi;
export { appApi, geoApi, ticketControlApi };